// our service
var SERVICE = 'forge-ui';

// static values to pass to atl-attribution header taken from go/workday
var BUSINESS_UNIT = 'Ecosystem Engineering';
var COST_CENTER = '3039';
var TEAM = 'Eng - Ecosystem - Developer Platform - UI';
export var createAtlAttributionHeader = function createAtlAttributionHeader(workspaceAri) {
  return JSON.stringify({
    atlWorkspaceAri: workspaceAri,
    service: SERVICE,
    businessUnit: BUSINESS_UNIT,
    costCenter: COST_CENTER,
    team: TEAM
  });
};